/**
 * Texting helpers shared by Messages and the staff texting check: how many segments a text
 * takes, and shrinking a picture to what carriers take.
 */

/** GSM-7 (160 a segment, 153 when split) unless a character needs UCS-2 (70, then 67). As the server counts. */
const GSM = new Set(
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^{}\\[~]|€'.split('')
);
export function segments(text: string): { encoding: 'gsm' | 'ucs2'; count: number; perSegment: number; used: number } {
  const chars = [...text];
  const gsm = chars.every((c) => GSM.has(c));
  const used = gsm ? chars.reduce((n, c) => n + ('^{}\\[~]|€'.includes(c) ? 2 : 1), 0) : text.length;
  const [one, many] = gsm ? [160, 153] : [70, 67];
  return { encoding: gsm ? 'gsm' : 'ucs2', count: used === 0 ? 0 : used <= one ? 1 : Math.ceil(used / many), perSegment: used <= one ? one : many, used };
}

/** Shrinks a picture in the browser to what carriers take (about 1,280 px and well under 1 MB). */
export async function shrinkPicture(file: File): Promise<string> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, 1280 / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  for (const q of [0.82, 0.7, 0.55, 0.4]) {
    const url = canvas.toDataURL('image/jpeg', q);
    if (url.length * 0.75 < 600 * 1024) return url;
  }
  throw new Error('That picture is too big even after shrinking it.');
}
